import React from 'react';
import PropTypes from 'prop-types';
import { ActionList, ActionListOptionTypes } from '../ActionList';
import styles from '@dtsl/css-breadcrumb/dist/index.module.css';
import Slash2 from '@dtsl/icons/dist/icons/react/Slash2';
function BreadcrumbEllipsisItem(props) {
  const {
    breadcrumb,
    onSelect,
    ellipsisAriaLabel
  } = props;
  const onSelectHandler = (option, key, event) => {
    onSelect(option, key, event);
    const {
      url = '#',
      target = '_self'
    } = option;
    window.open(url, target);
  };
  const options = [{
    type: ActionListOptionTypes.SECTION_LIST,
    items: breadcrumb.map(option => ({
      id: option.index,
      title: option.label,
      disabled: option.disabled,
      onSelect: event => {
        onSelectHandler(option, option.index, event);
      }
    }))
  }];
  return /*#__PURE__*/React.createElement("li", {
    className: styles['sib-breadcrumb-items']
  }, /*#__PURE__*/React.createElement(ActionList, {
    options: options,
    placement: "bottomLeft",
    triggerButtonMetaData: {
      label: '...',
      variant: 'tertiary',
      ariaLabel: ellipsisAriaLabel,
      className: styles['sib-breadcrumb-item__ellipsis']
    }
  }), /*#__PURE__*/React.createElement(Slash2, {
    className: styles['sib-breadcrumb-item__separator']
  }));
}
BreadcrumbEllipsisItem.defaultProps = {
  onSelect: () => {},
  breadcrumb: [],
  indexSelected: 0,
  index: 0,
  ellipsisAriaLabel: 'show more breadcrumbs'
};
BreadcrumbEllipsisItem.propTypes = {
  onSelect: PropTypes.func,
  ellipsisAriaLabel: PropTypes.func,
  breadcrumb: PropTypes.arrayOf(PropTypes.shape({
    url: PropTypes.string,
    target: PropTypes.string,
    label: PropTypes.string,
    disabled: PropTypes.bool,
    className: PropTypes.string,
    index: PropTypes.number
  }))
};
export default BreadcrumbEllipsisItem;